import { api } from '../../../apiAxios';
import { urlHttpGov } from '../../../urls';
import { getToken } from '../../../LStorage/token';

class RecibosImportarService {
    private baseURL: string = `${urlHttpGov}${process.env.REACT_APP_BACKEND === 'local' ? '' : '/gestor'}/receipt/import`;

    async getRecibos(idEntity: any, signal?: AbortSignal): Promise<any> {

        let { data } = await api.get(`${this.baseURL}/${idEntity}`,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                },
                signal
            });

        return data;
    }

    async postRecibosJson(
        obj: any,
        signal?: AbortSignal
    ): Promise<any> {

        let { data } = await api.post(`${this.baseURL}`,
            obj,
            {
                headers: {
                    Authorization: "Bearer " + getToken(),
                },
                signal
            });

        return data;
    }

}

// eslint-disable-next-line import/no-anonymous-default-export
export default new RecibosImportarService();
